import { Injectable } from '@angular/core';
import { AuthorizationData } from 'fl-platform-authorizer';
import { DataModel, TokenService as LibraryTokenService, createTokenService } from 'qp-storefront';
import { LocalStorageKeys } from '../../../LocalStorageKeys';
import { ConfigService } from '../../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private tokenService: LibraryTokenService | undefined;

  constructor(private configService: ConfigService) {}
  public fetchGuestToken(deviceId: string, deviceName: string, authData?: AuthorizationData): Promise<DataModel> {
    let accessToken = window.sessionStorage.getItem(LocalStorageKeys.AUTHDATA);
    if (authData) {
      accessToken = authData.accessToken;
    }
    if (!this.tokenService) {
      this.tokenService = createTokenService(this.configService.applicationConfig.guestFlatURL);
    }
    return this.tokenService.getOvatToken(deviceId, deviceName, accessToken);
  }
}
